export type Language = 'lv' | 'en';

export const translations = {
  // App name
  'app.name': {
    lv: 'Bedru Lietotne',
    en: 'PotHole App',
  },

  // Navigation
  'nav.dashboard': {
    lv: 'Pārskats',
    en: 'Dashboard',
  },
  'nav.settings': {
    lv: 'Iestatījumi',
    en: 'Settings',
  },
  'nav.admin': {
    lv: 'Administrācija',
    en: 'Admin',
  },
  'nav.logout': {
    lv: 'Iziet',
    en: 'Logout',
  },

  // Login page
  'login.title': {
    lv: 'Pieslēgties',
    en: 'Sign In',
  },
  'login.email': {
    lv: 'E-pasts',
    en: 'Email',
  },
  'login.password': {
    lv: 'Parole',
    en: 'Password',
  },
  'login.submit': {
    lv: 'Pieslēgties',
    en: 'Sign In',
  },
  'login.error': {
    lv: 'Nepareizs e-pasts vai parole',
    en: 'Invalid email or password',
  },

  // Dashboard
  'dashboard.title': {
    lv: 'Bedru karte',
    en: 'Pothole Map',
  },
  'dashboard.viewAndFilters': {
    lv: 'Skats un filtri',
    en: 'View & Filters',
  },
  'dashboard.viewMode': {
    lv: 'Skata režīms',
    en: 'View Mode',
  },
  'dashboard.heatmap': {
    lv: 'Blīvuma karte',
    en: 'Heatmap',
  },
  'dashboard.points': {
    lv: 'Punkti',
    en: 'Points',
  },
  'dashboard.timeFilter': {
    lv: 'Laika filtrs',
    en: 'Time Filter',
  },
  'dashboard.allTime': {
    lv: 'Viss laiks',
    en: 'All time',
  },
  'dashboard.lastHours': {
    lv: 'Pēdējās {hours} stundas',
    en: 'Last {hours} hours',
  },
  'dashboard.refresh': {
    lv: 'Atjaunot',
    en: 'Refresh',
  },
  'dashboard.showing': {
    lv: 'Rāda',
    en: 'Showing',
  },
  'dashboard.potholes': {
    lv: 'bedres',
    en: 'potholes',
  },
  'dashboard.total': {
    lv: 'Kopā',
    en: 'Total',
  },
  'dashboard.heatmapHint': {
    lv: 'Vēsturiski dati: ietver bedres, kas bija aktīvas izvēlētajā periodā.',
    en: 'Historical data: includes potholes active during selected period.',
  },
  'dashboard.pointsHint': {
    lv: 'Pašreiz aktīvās bedres. Katrs marķieris ir atsevišķa bedre.',
    en: 'Currently active potholes. Each marker is an individual pothole.',
  },
  'dashboard.loading': {
    lv: 'Ielādē...',
    en: 'Loading...',
  },
  'dashboard.error': {
    lv: 'Neizdevās ielādēt bedru datus',
    en: 'Failed to fetch pothole data',
  },
  'dashboard.autoRefresh': {
    lv: 'Automātiska atjaunošana',
    en: 'Auto-refresh',
  },
  'dashboard.lastUpdated': {
    lv: 'Atjaunots',
    en: 'Updated',
  },
  'dashboard.justNow': {
    lv: 'tikko',
    en: 'just now',
  },
  'dashboard.minuteAgo': {
    lv: 'pirms 1 minūtes',
    en: '1 minute ago',
  },
  'dashboard.minutesAgo': {
    lv: 'pirms {minutes} minūtēm',
    en: '{minutes} minutes ago',
  },

  // Map popups
  'map.potholes': {
    lv: 'bedres',
    en: 'potholes',
  },
  'map.inThisArea': {
    lv: 'šajā zonā',
    en: 'in this area',
  },
  'map.clickToZoom': {
    lv: 'Klikšķini, lai pietuvinātu',
    en: 'Click to zoom in',
  },
  'map.reliability': {
    lv: 'Uzticamība',
    en: 'Reliability',
  },
  'map.reported': {
    lv: 'Ziņots',
    en: 'Reported',
  },

  // Settings
  'settings.title': {
    lv: 'Iestatījumi',
    en: 'Settings',
  },
  'settings.changePassword': {
    lv: 'Mainīt paroli',
    en: 'Change Password',
  },
  'settings.currentPassword': {
    lv: 'Pašreizējā parole',
    en: 'Current Password',
  },
  'settings.newPassword': {
    lv: 'Jaunā parole',
    en: 'New Password',
  },
  'settings.confirmPassword': {
    lv: 'Apstiprināt paroli',
    en: 'Confirm Password',
  },
  'settings.save': {
    lv: 'Saglabāt',
    en: 'Save',
  },
  'settings.language': {
    lv: 'Valoda',
    en: 'Language',
  },

  // Admin
  'admin.dashboard': {
    lv: 'Administrācijas pārskats',
    en: 'Admin Dashboard',
  },
  'admin.users': {
    lv: 'Lietotāji',
    en: 'Users',
  },
  'admin.logs': {
    lv: 'Žurnāli',
    en: 'Logs',
  },
  'admin.addUser': {
    lv: 'Pievienot lietotāju',
    en: 'Add User',
  },
  'admin.editUser': {
    lv: 'Rediģēt lietotāju',
    en: 'Edit User',
  },
  'admin.deleteUser': {
    lv: 'Dzēst lietotāju',
    en: 'Delete User',
  },
  'admin.email': {
    lv: 'E-pasts',
    en: 'Email',
  },
  'admin.role': {
    lv: 'Loma',
    en: 'Role',
  },
  'admin.status': {
    lv: 'Statuss',
    en: 'Status',
  },
  'admin.active': {
    lv: 'Aktīvs',
    en: 'Active',
  },
  'admin.inactive': {
    lv: 'Neaktīvs',
    en: 'Inactive',
  },
  'admin.actions': {
    lv: 'Darbības',
    en: 'Actions',
  },
  'admin.created': {
    lv: 'Izveidots',
    en: 'Created',
  },
  'admin.lastActive': {
    lv: 'Pēdējā aktivitāte',
    en: 'Last Active',
  },
  'admin.never': {
    lv: 'Nekad',
    en: 'Never',
  },
  'admin.user': {
    lv: 'Lietotājs',
    en: 'User',
  },
  'admin.action': {
    lv: 'Darbība',
    en: 'Action',
  },
  'admin.ipAddress': {
    lv: 'IP adrese',
    en: 'IP Address',
  },
  'admin.timestamp': {
    lv: 'Laiks',
    en: 'Timestamp',
  },
  'admin.details': {
    lv: 'Detaļas',
    en: 'Details',
  },
  'admin.backToApp': {
    lv: 'Atpakaļ uz lietotni',
    en: 'Back to App',
  },
  'admin.userManagement': {
    lv: 'Lietotāju pārvaldība',
    en: 'User Management',
  },
  'admin.accessLogs': {
    lv: 'Piekļuves žurnāli',
    en: 'Access Logs',
  },
  'admin.systemOverview': {
    lv: 'Sistēmas pārskats',
    en: 'System Overview',
  },
  'admin.totalUsers': {
    lv: 'Kopā lietotāju',
    en: 'Total Users',
  },
  'admin.activeUsers': {
    lv: 'Aktīvi lietotāji',
    en: 'Active Users',
  },
  'admin.adminUsers': {
    lv: 'Administratori',
    en: 'Admin Users',
  },
  'admin.logs24h': {
    lv: 'Žurnāli (24h)',
    en: 'Logs (24h)',
  },
  'admin.blockedIPs': {
    lv: 'Bloķētās IP',
    en: 'Blocked IPs',
  },
  'admin.unblock': {
    lv: 'Atbloķēt',
    en: 'Unblock',
  },
  'admin.permanent': {
    lv: 'Pastāvīgi',
    en: 'Permanent',
  },
  'admin.blockedAt': {
    lv: 'Bloķēts',
    en: 'Blocked At',
  },
  'admin.blockedUntil': {
    lv: 'Bloķēts līdz',
    en: 'Blocked Until',
  },
  'admin.reason': {
    lv: 'Iemesls',
    en: 'Reason',
  },
  'admin.refresh': {
    lv: 'Atjaunot',
    en: 'Refresh',
  },
  'admin.actionType': {
    lv: 'Darbības veids',
    en: 'Action Type',
  },
  'admin.allActions': {
    lv: 'Visas darbības',
    en: 'All Actions',
  },
  'admin.noLogs': {
    lv: 'Žurnāli nav atrasti',
    en: 'No logs found',
  },
  'admin.unknown': {
    lv: 'Nezināms',
    en: 'Unknown',
  },
  'admin.you': {
    lv: 'Tu',
    en: 'You',
  },
  'admin.revokeAccess': {
    lv: 'Atsaukt piekļuvi',
    en: 'Revoke Access',
  },
  'admin.confirmDelete': {
    lv: 'Apstiprināt dzēšanu',
    en: 'Confirm Delete',
  },
  'admin.deleteConfirmText': {
    lv: 'Vai tiešām vēlaties dzēst lietotāju',
    en: 'Are you sure you want to delete user',
  },
  'admin.cannotUndo': {
    lv: 'Šo darbību nevar atsaukt.',
    en: 'This action cannot be undone.',
  },
  'admin.newPasswordHint': {
    lv: 'Jauna parole (atstāt tukšu, lai saglabātu)',
    en: 'New Password (leave empty to keep)',
  },
  'admin.addNewUser': {
    lv: 'Pievienot jaunu lietotāju',
    en: 'Add New User',
  },
  'admin.userCreated': {
    lv: 'Lietotājs veiksmīgi izveidots',
    en: 'User created successfully',
  },
  'admin.userUpdated': {
    lv: 'Lietotājs veiksmīgi atjaunināts',
    en: 'User updated successfully',
  },
  'admin.userDeleted': {
    lv: 'Lietotājs veiksmīgi dzēsts',
    en: 'User deleted successfully',
  },
  'admin.accessRevoked': {
    lv: 'Piekļuve veiksmīgi atsaukta',
    en: 'Access revoked successfully',
  },
  'admin.operationFailed': {
    lv: 'Darbība neizdevās',
    en: 'Operation failed',
  },
  'admin.failedLoadUsers': {
    lv: 'Neizdevās ielādēt lietotājus',
    en: 'Failed to load users',
  },
  'admin.failedLoadStats': {
    lv: 'Neizdevās ielādēt statistiku',
    en: 'Failed to load statistics',
  },
  'admin.failedLoadLogs': {
    lv: 'Neizdevās ielādēt žurnālus',
    en: 'Failed to load logs',
  },

  // Common
  'common.cancel': {
    lv: 'Atcelt',
    en: 'Cancel',
  },
  'common.save': {
    lv: 'Saglabāt',
    en: 'Save',
  },
  'common.delete': {
    lv: 'Dzēst',
    en: 'Delete',
  },
  'common.edit': {
    lv: 'Rediģēt',
    en: 'Edit',
  },
  'common.close': {
    lv: 'Aizvērt',
    en: 'Close',
  },
  'common.yes': {
    lv: 'Jā',
    en: 'Yes',
  },
  'common.no': {
    lv: 'Nē',
    en: 'No',
  },
  'common.loading': {
    lv: 'Ielādē...',
    en: 'Loading...',
  },

  // Login
  'login.subtitle': {
    lv: 'Pieslēdzieties, lai skatītu bedru datus',
    en: 'Sign in to view pothole data',
  },
  'login.error.default': {
    lv: 'Pieslēgšanās neizdevās. Mēģiniet vēlreiz.',
    en: 'Login failed. Please try again.',
  },

  // Settings page
  'settings.accountInfo': {
    lv: 'Konta informācija',
    en: 'Account Information',
  },
  'settings.mapSettings': {
    lv: 'Noklusējuma kartes iestatījumi',
    en: 'Default Map Settings',
  },
  'settings.defaultHours': {
    lv: 'Noklusējuma stundas atpakaļ',
    en: 'Default Hours Back',
  },
  'settings.savePreferences': {
    lv: 'Saglabāt iestatījumus',
    en: 'Save Preferences',
  },
  'settings.preferencesSaved': {
    lv: 'Iestatījumi saglabāti veiksmīgi',
    en: 'Preferences saved successfully',
  },
  'settings.preferencesFailed': {
    lv: 'Neizdevās saglabāt iestatījumus',
    en: 'Failed to save preferences',
  },
  'settings.preferencesLoadFailed': {
    lv: 'Neizdevās ielādēt iestatījumus',
    en: 'Failed to load preferences',
  },
  'settings.passwordChanged': {
    lv: 'Parole nomainīta veiksmīgi',
    en: 'Password changed successfully',
  },
  'settings.passwordChangeFailed': {
    lv: 'Neizdevās nomainīt paroli',
    en: 'Failed to change password',
  },
  'settings.passwordMismatch': {
    lv: 'Jaunās paroles nesakrīt',
    en: 'New passwords do not match',
  },
  'settings.passwordTooShort': {
    lv: 'Parolei jābūt vismaz 8 simboliem',
    en: 'Password must be at least 8 characters',
  },
  'settings.passwordHint': {
    lv: 'Vismaz 8 simboli',
    en: 'Minimum 8 characters',
  },
  'settings.languageLabel': {
    lv: 'Lietotnes valoda',
    en: 'Application Language',
  },

  // Navigation
  'nav.map': {
    lv: 'Karte',
    en: 'Map',
  },
  'nav.adminPanel': {
    lv: 'Administrācijas panelis',
    en: 'Admin Panel',
  },
  'nav.potholeMap': {
    lv: 'Bedru karte',
    en: 'Pothole Map',
  },

  // Time labels
  'time.hours': {
    lv: 'st.',
    en: 'h',
  },
  'time.days': {
    lv: 'd.',
    en: 'd',
  },
  'time.all': {
    lv: 'Viss',
    en: 'All',
  },
} as const;

export type TranslationKey = keyof typeof translations;
